import {
  DELETE_AACOUNT,
  GET_ACCOUNTS,
  GET_ACCOUNTS_COUNT,
  GET_FACTURAS,
  GET_FACTURAS_COUNT,
  SIGN_IN,
  SIGN_OUT,
} from './types';

export const reducer = (state, action) => {
  switch (action.type) {
    case SIGN_IN:
      return { ...state, token: action.value.token, role: action.value.role };
    case SIGN_OUT:
      return { token: '', role: '', accounts: [], count: 0, facturas: [], facturasCount: 0 };
    case GET_ACCOUNTS:
      return { ...state, accounts: action.value };
    case GET_ACCOUNTS_COUNT:
      return { ...state, count: action.value };
    case GET_FACTURAS:
      return { ...state, facturas: action.value };
    case GET_FACTURAS_COUNT:
      return { ...state, facturasCount: action.value };
    case DELETE_AACOUNT: {
      return { ...state, accounts: state.accounts.filter((item) => item._id !== action.value), count: state.count - 1 };
    }
    default:
      return state;
  }
};
